module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAbElEQVQ4y2NgGBTgPx5wScAEJ8ZqwJZL78g3YM6Rl/8Z0o/933vjA3kGPHz74//VZ9/+v/r0i3wvkBUGIGfjwvgAyQZ8WLuLfAPer9gKdvbHbQfJM+Dn3Uf/v5658v/X4+fke4HiMMBtwJAGAF0+zgs9NV5HAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/PA.png
// module id = 1236
// module chunks = 0